import * as React from "react";
import { connect } from "react-redux";
import { ApplicationState } from "../../../redux/reducers";
import { logout } from "../../../redux/auth/creators";

import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import MenuAppBar from "../../../App/Components/AppBar/AppBar";
import AppFooter from "../../../App/Components/AppFooter/AppFooter";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@material-ui/icons/Close";
import FindInPageIcon from "@material-ui/icons/FindInPage";
import revoke from "../../../assets/images/revoke.svg";
import "./style.scss";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import LinearProgress from "@material-ui/core/LinearProgress";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
	getDashboardInfo,
	getCertificates,
	updateRecipient,
	//  ,getCommunications
} from "../../../redux/ui/creators";
import { getIssuer } from "../../../redux/auth/creators";
import { addToast } from "../../../redux/ui/creators";

import Payments from "../Payments/Payments";

import Translate from "../../../i18n/translationComponent";
import getConfig from "../../../aws-config";
import { Card, CardContent, Checkbox, Link, TextField } from "@material-ui/core";
import { http } from "../../../redux/utils";
const environment = getConfig();

interface StateProps {
	dashboard: any;
	dashboardInfoLoading: boolean;
	user: any;
	issuer: any;
	certificates: any[];
	// communications: any[];
	recipient: any;
}
interface RequiredProps {
	children?: JSX.Element;
}
interface OptionalProps {
	logout: any;
	getDashboardInfo: any;
	getCertificates: any;
	// getCommunications: any;
	getIssuer: any;
	addToast: any;
	updateRecipient: any;
}
type Props = StateProps & RequiredProps & OptionalProps;

class Dashboard extends React.Component<
	Props,
	{
		loading: any;
		certificatesLoading: boolean;
		paymentModalOpen: boolean;
		exportModalOpen: boolean;
		exportYear: number;
		selectedCertificate: any;
		countryCode: any;
		query: string;
		searchRef: any;
	}
> {
	componentWillMount() {
		console.log("dashboard mmounted with user: ", this.props.user.attributes.email);
		this.setState({
			loading: true,
			certificatesLoading: true,
			paymentModalOpen: false,
			selectedCertificate: null,
			query: "",
			exportModalOpen: false,
			exportYear: new Date().getFullYear(),
		});

		this.props.getDashboardInfo().then((r: any) => {
			if (r.status === 200) {
				this.setState({ ...this.state, loading: false });
				this.props.addToast({ type: "success", message: "Dashboard data loaded successfully." });
			} else {
				this.setState({ loading: false });
				this.props.addToast({ type: "error", message: "Could not load Dashboard data." });
			}
		});

		this.fetchCertificates();

		this.props.getIssuer(this.props.user.attributes.email).then((r: any) => {
			console.log(this.props.issuer);
			if (this.props.issuer) {
				console.log("IS ISSUER");
			} else {
				console.log("IS NOT ISSUER");
			}
		});
	}

	fetchCertificates = () => {
		this.setState({ certificatesLoading: true });
		this.props.getCertificates().then((r: any) => {
			if (r.status === 200) {
				this.setState({ certificatesLoading: false });
			} else {
				this.setState({ certificatesLoading: false });
				this.props.addToast({ type: "error", message: "Could not load certificates." });
			}
		});
	};
	handleSearchChange = (e: any) => {
		this.setState({ ...this.state, query: e.target.value });
	};

	componentWillReceiveProps(next: any) {
		this.setState({
			loading: next.dashboardInfoLoading,
		});
	}
	componentDidMount() {
		fetch("https://ipinfo.io/?token=" + environment.ipapi_key)
			.then((r: any) => r.json())
			.then((r: any) => {
				console.log(r);
				this.setState({ countryCode: r.country });
			})
			.catch((e: any) => {
				console.log(e);
			});
	}
	handleOpenPaymentModal = (certificate: any) => {
		this.setState({ paymentModalOpen: true, selectedCertificate: certificate });
	};

	handleClosePaymentModal = () => {
		this.setState({ paymentModalOpen: false });
	};
	handleCloseExportModal = () => {
		this.setState({ exportModalOpen: false });
	};
	handleOpenExportModal = () => {
		this.setState({ exportModalOpen: true });
	};

	handlePaymentSuccess = () => {
		console.log("function call");
		this.setState({ paymentModalOpen: false });

		this.props.addToast({ type: "success", message: "Payment successfull" });
		let count = 0;
		window.location.reload();
		const interval = setInterval(() => {
			const cert = this.props.certificates.find((c: any) => c.credential_id === this.state.selectedCertificate.credential_id);
			console.log("certificate: : : ", cert);
			if (cert.status === "Payment Required" || count > 10) {
				clearInterval(interval);
			} else {
				this.props.getCertificates().then((r: any) => {
					if (r.status === 200) {
					} else {
						this.props.addToast({ type: "error", message: "Could not load certificates." });
					}
				});
				count++;
			}
		}, 1500);
	};

	handlePaymentError = () => {
		this.props.addToast({ type: "error", message: "Could not complete payment" });
	};

	handleButtonClick = (certificate: any) => {
		console.log("handlle click for certificate", certificate);
		this.handleOpenPaymentModal(certificate);
	};
	handleUpdateRecipient = () => {
		console.log("update shared credentials to: ", !this.props.recipient.share_certs);
		this.setState({ ...this.state, loading: true });
		const recipientName = this.props.recipient.name || this.props.certificates[this.props.certificates.length - 1].recipient_name;
		this.props.updateRecipient({ share_certs: !this.props.recipient.share_certs, name: recipientName }).then((r: any) => {
			this.setState({ ...this.state, loading: false });
			if (r.status === 200) {
				this.props.addToast({ type: "success", message: "Settings Saved" });
			} else {
				this.props.addToast({ type: "error", message: "Error saving settings" });
			}
		});
	};
	renderView = (certificate: any) => {
		console.log("view cert: ", certificate);
		return certificate.status !== "Expired" && certificate.status !== "Revoked" ? (
			<>
				<Button variant="contained" color="primary" className=" mt-20 mb-20 " onClick={() => this.handleViewCertificate(certificate.view_url)}>
					<Translate text="View" />
				</Button>
				<Button variant="contained" color="primary" className="ml-20 mt-20 mb-20 success" onClick={() => this.handleViewCertificate(certificate.verify_url)}>
					<Translate text="Verify" />
				</Button>
			</>
		) : (
			<Tooltip title={`This certificate is ${certificate.status.toLowerCase()}`}>
				<img src={revoke} alt="revoked or expired" height="36" />
			</Tooltip>
		);
	};

	handleViewCertificate = (path: string) => {
		let link = document.createElement("a");
		link.setAttribute("href", path);
		link.setAttribute("target", "_blank");
		document.body.appendChild(link); // Required for FF

		link.click();
	};
	handleSharableLinkClick = () => {
		// copy the text to clipboard and display a toast
		const el = document.createElement("textarea");
		el.value = `${getConfig().app_url}/credentials/${this.props.recipient.recipient_id}`;
		document.body.appendChild(el);
		el.select();
		document.execCommand("copy");
		document.body.removeChild(el);
		this.props.addToast({ type: "success", message: "Link copied to clipboard" });
	};
	handleExport = () => {
		http
			.get(`export-batch-recipient?year=${this.state.exportYear}`)
			.then((r: any) => {
				console.log(r);
				if (r.status === 200) {
					const link = document.createElement("a");
					link.href = r.data.url;
					link.setAttribute("download", `export-${this.state.exportYear}.csv`);
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					this.props.addToast({ type: "success", message: "Exported Successfully." });
				} else {
					this.props.addToast({ type: "error", message: "No files found." });
				}
			})
			.catch((e: any) => {
				console.log(e);
				this.props.addToast({ type: "error", message: "No files found." });
			})
			.finally(() => {
				this.setState({ ...this.state, exportModalOpen: false });
			});
	};
	renderExportModal = () => {
		return (
			<Dialog
				open={this.state.exportModalOpen}
				onClose={this.handleCloseExportModal}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				{/* <DialogTitle id="alert-dialog-title">{"Use Google's location service?"}</DialogTitle> */}
				<DialogTitle disableTypography style={{ display: "flex", justifyContent: "space-between", paddingBottom: 0 }}>
					{/* <Typography variant="h6">{children}</Typography> */}
					<Typography gutterBottom variant="h6" component="h6">
						<Translate text="Export Certificates" />
					</Typography>
					<IconButton aria-label="close" onClick={this.handleCloseExportModal} style={{ marginTop: "-10px", marginRight: "-10px" }}>
						<CloseIcon />
					</IconButton>
				</DialogTitle>
				<DialogContent className="payment-modal">
					<DialogContentText id="alert-dialog-description">
						<Translate text="Select the year for which you want to export the certificates." />
					</DialogContentText>
					{/* year selector for the certificates to export with a dropdown for the last 6 years dynamically*/}
					<TextField
						id="outlined-select-currency-native"
						select
						value={this.state.exportYear}
						SelectProps={{
							native: true,
						}}
						variant="outlined"
						onChange={(e: any) => {
							this.setState({ ...this.state, exportYear: e.target.value });
						}}
					>
						{Array.from({ length: 6 }, (_, i) => new Date().getFullYear() - i).map((year) => (
							<option key={year} value={year}>
								{year}
							</option>
						))}
					</TextField>
				</DialogContent>

				<DialogActions>
					<Button onClick={this.handleCloseExportModal} color="primary">
						Cancel
					</Button>
					<Button onClick={this.handleExport} color="primary" autoFocus>
						Export
					</Button>
				</DialogActions>
			</Dialog>
		);
	};

	render() {
		return (
			<>
				<MenuAppBar logout={this.props.logout} isIssuer={!!this.props.issuer} />
				{this.state.loading && <LinearProgress />}
				<Backdrop open={this.state.certificatesLoading} style={{ zIndex: 1300, color: "#fff" }}>
					<CircularProgress color="inherit" />
				</Backdrop>
				<Container className="dashboard-inner">
					<Grid container component="main" spacing={2}>
						<Grid item xs={12} sm={12} md={12} component={Box}>
							{/* <EasyStepCard /> */}
						</Grid>
						{!this.state.certificatesLoading && this.props.certificates.length ? (
							<>
								<Grid container>
									<Grid item>
										<Typography gutterBottom variant="h6" component="h6">
											<Translate text="My Credentials" />
										</Typography>
									</Grid>
								</Grid>
								<Grid container component={Box} className="certificate-list" spacing={2}>
									<Grid item xs={12}>
										<Grid container alignItems="center" justifyContent="space-between">
											<Grid item>
												<TextField
													className="search-field"
													label="Search"
													variant="outlined"
													inputRef={this.state.searchRef}
													value={this.state.query}
													onChange={this.handleSearchChange}
												/>
											</Grid>
											<Grid item>
												<Button variant="contained" color="primary" onClick={this.handleOpenExportModal}>
													Export
												</Button>
												{this.renderExportModal()}
											</Grid>
										</Grid>
									</Grid>
									<Grid item xs={12}>
										<Checkbox
											disabled={this.state.loading}
											color="primary"
											inputProps={{ "aria-label": "secondary checkbox" }}
											name="publicCertificates"
											checked={this.props.recipient.share_certs === 1}
											onChange={this.handleUpdateRecipient}
											style={{ padding: 0 }}
										/>
										<label htmlFor="publicCertificates">
											<Translate text="Activate the feature to share this page via a link." />
										</label>
										{this.props.recipient?.share_certs === 1 && (
											<Typography display="inline">
												<Translate text="Share this link to allow others to view your certificates:" />{" "}
												<Tooltip title="Click to copy to clipboard">
													<Link onClick={this.handleSharableLinkClick} style={{ cursor: "pointer", wordBreak: "break-word" }}>{`${
														getConfig().app_url
													}/credentials/${this.props.recipient.recipient_id}`}</Link>
												</Tooltip>
											</Typography>
										)}
									</Grid>
								</Grid>
								<Grid container component={Box} className="certificate-list" spacing={2} style={{ marginTop: 2 }}>
									{this.props.certificates
										.filter((cert: any) => {
											const searchFields = ["certificate_name", "certificate_type", "issued_dt", "issuer_name", "recipient_name"];
											console.log(cert);
											// for (const [key, value] of Object.entries(cert) as typeof cert) {
											// 	console.log(`${key}: ${value}`);
											// 	if (String(value).toLowerCase().includes(this.state.query.toLowerCase())) {
											// 		return true;
											// 	}
											// }
											for (const field of searchFields) {
												if (String(cert[field]).toLowerCase().includes(this.state.query.toLowerCase())) {
													return true;
												}
											}
											return false;
										})
										.map((certificate: any, index: number) => {
											return (
												<Grid item xs={12} sm={6} md={4} className="certificate" key={index}>
													<div className="certificate-inner">
														<img style={{ maxWidth: "100%", width: "100%" }} src={certificate.image_url} alt="certificate" />
														<Typography gutterBottom variant="h6" component="h6">
															{certificate.certificate_name}
														</Typography>
														<Typography gutterBottom variant="subtitle1" component="h6">
															{certificate.certificate_type}
														</Typography>
														<Typography gutterBottom variant="caption" component="h6">
															<Translate text="Issue Date" />: {certificate.issued_dt}
														</Typography>
														<Typography gutterBottom variant="caption" component="h6">
															<Translate text="By" />: {certificate.issuer_name}
														</Typography>
														{certificate.status === "Payment Required" && !certificate.exempted_countries?.includes(this.state.countryCode) ? (
															<Button
																variant="contained"
																color="secondary"
																type="submit"
																className="mt-20 mb-20"
																onClick={() => this.handleButtonClick(certificate)}
															>
																<Translate text="purchase_for" />
																{certificate.certificate_price} USD
															</Button>
														) : (
															this.renderView(certificate)
														)}
													</div>
												</Grid>
											);
										})}
								</Grid>
							</>
						) : !this.state.certificatesLoading ? (
							<div style={{ margin: "0 auto", width: "50%" }}>
								<Card style={{ padding: "40px", textAlign: "center" }}>
									<CardContent>
										<FindInPageIcon />
										<Typography>No certificates found.</Typography>
									</CardContent>
								</Card>
							</div>
						) : null}
					</Grid>
					<Dialog
						open={this.state.paymentModalOpen}
						onClose={this.handleClosePaymentModal}
						aria-labelledby="alert-dialog-title"
						aria-describedby="alert-dialog-description"
					>
						{/* <DialogTitle id="alert-dialog-title">{"Use Google's location service?"}</DialogTitle> */}
						<DialogTitle disableTypography style={{ display: "flex", justifyContent: "space-between", paddingBottom: 0 }}>
							{/* <Typography variant="h6">{children}</Typography> */}
							<Typography gutterBottom variant="h6" component="h6">
								<Translate text="You are purchasing" />:
							</Typography>
							<IconButton aria-label="close" onClick={this.handleClosePaymentModal} style={{ marginTop: "-10px", marginRight: "-10px" }}>
								<CloseIcon />
							</IconButton>
						</DialogTitle>

						{this.state.selectedCertificate && (
							<DialogContent className="payment-modal">
								{/* <Typography gutterBottom variant="h6" component="h6">
									You are purchasing:
								</Typography> */}
								<section className="cert-info">
									<div className="left">
										<img style={{ maxWidth: "100%" }} src={this.state.selectedCertificate.image_url} alt="Certificate preview" />
									</div>
									<div className="right">
										<Typography gutterBottom variant="subtitle2" component="p">
											{this.state.selectedCertificate.certificate_name}
										</Typography>
										<Typography gutterBottom variant="subtitle2" component="p">
											{this.state.selectedCertificate.certificate_type}
										</Typography>
										<Typography gutterBottom variant="subtitle2" component="p">
											<Translate text="Issue Date" />: {this.state.selectedCertificate.issued_dt}
										</Typography>
										<Typography gutterBottom variant="subtitle2" component="p">
											<Translate text="By" />: {this.state.selectedCertificate.issuer_name}
										</Typography>
									</div>
								</section>
								<Payments onSuccess={this.handlePaymentSuccess} onError={this.handlePaymentError} certificate={this.state.selectedCertificate} />
							</DialogContent>
						)}
						{/* <DialogActions>
              <Button onClick={this.handleClosePaymentModal} color="primary">
                Disagree
              </Button>
              <Button onClick={this.handleClosePaymentModal} color="primary" autoFocus>
                Agree
              </Button>
            </DialogActions> */}
					</Dialog>
				</Container>
				<AppFooter />
			</>
		);
	}
}

export default connect<any, any, any>(
	(state: ApplicationState | any) => {
		return {
			dashboard: state.ui.dashboard,
			dashboardInfoLoading: state.ui.isLoading,
			issuer: state.auth.issuer,
			user: state.auth.user,
			// communications: state.ui.communications,
			certificates: state.ui.certificates,
			recipient: state.ui.recipient,
		};
	},
	(dispatch: any) => {
		return {
			logout: dispatch(logout),
			getDashboardInfo: dispatch(getDashboardInfo),
			updateRecipient: dispatch(updateRecipient),
			getCertificates: dispatch(getCertificates),
			// getCommunications: dispatch(getCommunications),
			getIssuer: dispatch(getIssuer),
			addToast: dispatch(addToast),
		};
	}
)(Dashboard);
